// Traduce un error del SDK de Firebase a una clave i18n.
// El usuario nunca debe ver el texto en inglés del SDK: el caso real que
// originó esto fue un toast con "Missing or insufficient permissions." (#48).
const ERROR_KEYS_BY_CODE = {
  // Firestore rechaza la escritura porque no hay sesión (request.auth == null).
  'permission-denied': 'common.errors.sessionLost',
  unauthenticated: 'common.errors.sessionLost',
  // Sin red: Firestore no alcanza el backend, o Auth no puede firmar.
  unavailable: 'common.errors.connectionLost',
  'auth/network-request-failed': 'common.errors.connectionLost',
}

export const mapFirebaseError = error => ERROR_KEYS_BY_CODE[error?.code] ?? 'common.unexpectedError'
